<div class="content-container m-0">
    <div class="d-flex my-4">
        <div class="login-form mx-auto">
            <form (ngSubmit)="doSignin()" #signinForm="ngForm">
                <div class="d-flex mb-3 flex-column">
                    <img class="logo p-4" src="/assets/npy-logo.avif" alt="NPY Women's Council" />
                </div>

                <div class="demo-notice mb-3" role="note">
                    <strong>Demonstration only.</strong> All names and figures are fictional. Sign in with any demo account below, or type
                    one of their emails with any password.
                </div>

                @if (error) {
                <div class="alert alert-danger" role="alert">Error: {{ error }}</div>
                }

                <div class="form-group">
                    <label class="form-label" for="signin_email">Email or Username</label>
                    <input class="form-control" type="text" id="signin_email" name="email" required [(ngModel)]="signin.email" autocomplete="username" />
                </div>

                <div class="form-group">
                    <label class="form-label" for="signin_pass">Password</label>
                    <input
                        class="form-control"
                        type="password"
                        id="signin_pass"
                        name="password"
                        required
                        [(ngModel)]="signin.password"
                        autocomplete="current-password"
                    />
                </div>

                <div class="d-flex">
                    <input type="submit" value="Sign In" class="btn btn-primary ms-0 mb-4" [disabled]="!signinForm.form.valid || loading" />
                </div>

                <!--        <p class="my-0 small"><a routerLink="/password-reset">Forgot Password?</a></p>-->
            </form>

            <section class="demo-accounts" aria-labelledby="demo-accounts-title">
                <h2 class="demo-accounts-title" id="demo-accounts-title">Demo accounts</h2>
                <ul class="demo-account-list">
                    @for (account of demoAccounts; track account.persona.key) {
                    <li>
                        <button type="button" class="demo-account" (click)="signInAs(account)" [disabled]="loading">
                            <span class="demo-account-head">
                                <span class="demo-account-name">{{ account.persona.name }}</span>
                                <span class="demo-account-role">{{ account.role }}</span>
                            </span>
                            <span class="demo-account-title">{{ account.persona.title }}</span>
                            <span class="demo-account-sees">{{ account.sees }}</span>
                        </button>
                    </li>
                    }
                </ul>
                <p class="demo-accounts-foot">Password for every account: any text (e.g. "demo").</p>
            </section>
        </div>
    </div>
</div>
